import axios from "../axios-auth";
import orginal_axios from "axios";

export const denominationService = {
    getDenominationList,
    saveDenomination,
    getDenominationDetail,
    getDenominationListForPrint,
    getDenominationExcelExport
};

function getDenominationList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/denominations", { params });
}

function saveDenomination(denomination) {
    if (!denomination.id) {
        // new denomination
        return axios.post("/auth/denomination", denomination);
    } else {
        // edit
        return axios.put("/auth/denomination", denomination);
    }
}

function getDenominationDetail(id) {
    return axios.get("/auth/denomination/" + id);
}

function getDenominationListForPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/denominations", { params });
}

function getDenominationExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/denomination-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}